import React, { useState, useEffect, useContext, useLayoutEffect } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import FormControlLabel from "@mui/material/FormControlLabel";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import {
  CustomTextField,
  CustomTitle,
  CustomText,
  CustomButton,
  CustomButton1,
  CustomCheckbox,
} from "../../components/Custom";

import Service from "../../services";
import { useFormik } from "formik";

import validationSchema from "./validation";
import { AppContext } from "../../context";
import { Divider, FormControl, Typography } from "@mui/material";
// import toast from 'react-toastify';
// import Service from "../../services";



const API_URL = process.env.REACT_APP_API_URL;
const LogRequestPage = (props) => {
  const appdata = useContext(AppContext);
  const [requestTypes, setRequestTypes] = appdata[4];
  // const [locationPlanningData, setLocationPlanningData] = appdata[20];

  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState(false);
  const [update, setUpdate] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [errorMessages, setErrorMessages] = useState([]);


  const [requestFile, setRequestFile] = useState();

  const [openTemplate, setOpenTemplate] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState();
  const [bulkComment, setBulkComment] = useState("");
  const [showBulkComment, setShowBulkComment] = useState(false);

  const handleClickOpenTemplate = (id) => {
    setSelectedTemplate(id);
    setOpenTemplate(true);
  };

  const handleDownload = async () => {
    try {
      const csvContent = convertToCSV(errorMessages);
      downloadCSV(csvContent, 'error-details.csv');
    } catch (error) {
      console.error('Error downloading the file', error);
    }
  };

  function convertToCSV(data) {
    const headers = Object.keys(data[0]).join(',') + '\n';
    const rows = data.map(obj => Object.values(obj).join(',')).join('\n');
    return headers + rows;
}

function downloadCSV(content, fileName) {
  const blob = new Blob([content], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  link.setAttribute('href', url);
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

  const handleCloseTemplate = () => {
    setUpdate(true);
    setErrorMessages([]);
    setErrorMsg(false);
    setSubmitted(false);
    setOpenTemplate(false);
  };
  const handleShowComment = () => {
    setShowBulkComment(!showBulkComment);
  };
  const handleCommentChange = (e) => {
    setBulkComment(e.target.value);
  };

  //FETCH ALL REQUEST TYPES
  async function fetchRequestTypes() {
    const response = await Service.getRequestTypes();

    if (response.status === 200) {
      console.log(response);
      setRequestTypes(response.data.data);
    }
  }
  useEffect(() => {
    setUpdate(false);
    fetchRequestTypes();
  }, [update]);
  console.log(requestTypes);

  const navigate = useNavigate();

  const formik = useFormik({
    enableReinitialize: false,
    initialValues: { issueDescription: "" },
    validationSchema: validationSchema,
    onSubmit: (values, { resetForm }) => {
      alert(JSON.stringify(values, null, 4));
      // console.log(columnsRequired);
      console.log(
        Object.entries(values).map(([name, value]) => ({
          name,
          value,
        }))
      );
      saveFormData(selectedTemplate, resetForm);
    },
  });

  //HANDLE FORM SUBMIT
  async function saveFormData(requestId, resetForm) {
    let columnValues = Object.entries(formik.values).map(([name, value]) => ({
      name,
      value,
    }));
    columnValues.splice(
      columnValues.findIndex((a) => a.name === "issueDescription"),
      1
    );

    let payload = {
      request_id: requestId,
      columns: columnValues,
      comment: formik.values.issueDescription,
      staff_id: JSON.parse(sessionStorage.getItem("userDetails")).staff_id,
    };

    setErrorMsg(false);
    setSubmitted(false);
    setLoading(true);

    try {
      // console.log(payload);
      const response = await Service.logRequest(payload);
      if (response.status === 200 || response.status === 201) {
        setLoading(false);
        setSubmitted(true);
        setUpdate(true);
        resetForm();
      }
      else {
        let responseData = response;
        let errorMessages = responseData.message;
        console.log(errorMessages, 'error Messages')


        // Ensure errorMessages is always treated as an array
        if (!Array.isArray(errorMessages)) {
          errorMessages = [errorMessages];
        }

        if (errorMessages.length) {
          const failureMessages = errorMessages.map((item) => {
            const errorMessage = item || "An error occurred";
            return `${errorMessage}`;
          });

          setErrorMessages(failureMessages);
          setShowErrorModal(true);
        }
        setLoading(false);
        setErrorMsg(true);
      }
    } catch (error) {
      setLoading(false);
      console.log(error, "error messages")
    }
  }

  //HANDLE FILE IMPORT
  const changeHandler = (e) => {
    let fileUploaded = document.querySelector(`#${e.target.id}`);
    console.log(fileUploaded);
    let fileName = fileUploaded.value;
    let ext = fileName.substring(fileName.lastIndexOf(".") + 1);
    if (ext === "csv") {
      setRequestFile(e.target.files[0]);
    } else {
      alert("Invalid file format. Upload a .csv file");
    }
  };

  //File upload
  const [fileUploadSuccess, setFileUploadSuccess] = useState(false);
  const [fileUploadFail, setFileUploadFail] = useState(false);
  const [fileUploading, setFileUploading] = useState(false);
  const [invalidRows, setInvalidRows] = useState([]);

  //Bulk Request File submit
  async function handleFileSubmit(requestId) {
    console.log(requestId);
    setFileUploading(true);
    setShowBulkComment(false);
    setFileUploadSuccess(false);
    setFileUploadFail(false);
    setInvalidRows(false);
    const formData = new FormData();
    formData.append("file", requestFile);
    formData.append("request_id", requestId);
    formData.append("comment", bulkComment);
    formData.append(
      "staff_id",
      JSON.parse(sessionStorage.getItem("userDetails")).staff_id
    );
    let payload = formData;
    // console.log(payload);

    const response = await Service.logBulkRequest(payload);
    console.log(response);
    if (response.status === 200 || response.status === 201) {
      setFileUploading(false);
      setFileUploadSuccess(true);
    } else if (response.status === 403) {
      console.log(response?.data, response, "response")
      let errorMessages = response.data?.data.map(item => {
        return item.data; // Assuming the message is in the 'data' field as per your example
      });

      // Ensure errorMessages is always treated as an array
      if (!Array.isArray(errorMessages)) {
        errorMessages = [errorMessages];
      }
      console.log(errorMessages, 'error messages')

      setErrorMessages(errorMessages);
      setErrorMsg(true);
      setLoading(false);

      setFileUploading(false);
      setFileUploadSuccess(true);
      // setInvalidRows(true);
    } else {
      setFileUploading(false);
      setFileUploadFail(true);
    }
  }


  const handleClose = () => {
    setShowErrorModal(false);
  };

  return (
    <div className="container">
      <Box container>
        <Box>
          {/* <div>{displayForecastGroup}</div> */}
          <CustomTitle sx={{ fontSize: "20px", mb: 2 }}>
            Select Request Template
          </CustomTitle>

          <Box
            sx={{
              border: "1px solid",
              borderRadius: "10px",
              p: 2,
            }}
          >
            <List
              sx={{
                width: "100%",
              }}
              aria-label="contacts"
            >
              {requestTypes.map((item, index) => (
                <>
                  <ListItem key={index} fullWidth sx={{ py: 0 }}>
                    <ListItemButton
                      onClick={() => handleClickOpenTemplate(item.request_id)}
                    >
                      <Card
                        sx={{ width: "100%", boxShadow: "-3px 2px #d3d3d3" }}
                      >
                        <CardContent>
                          <Box>
                            <Typography
                              sx={{ fontWeight: "600" }}
                            >{`${item.request_name}`}</Typography>
                            <Typography
                              sx={{ fontSize: "13px" }}
                            >{`${item.description}`}</Typography>
                          </Box>
                        </CardContent>
                      </Card>
                    </ListItemButton>
                  </ListItem>
                </>
              ))}
              <Divider sx={{ mt: 3 }} />
              <CustomText sx={{ fontSize: "12px", textAlign: "center" }}>
                You have {requestTypes.length} templates
              </CustomText>
            </List>
            {requestTypes.length > 0 &&
              requestTypes.map((item, index) =>
                item.request_id === selectedTemplate ? (
                  <>
                    <Dialog
                      key={selectedTemplate}
                      open={openTemplate}
                      onClose={handleCloseTemplate}
                      fullWidth
                      maxWidth="md"
                    >
                      <DialogTitle> {item.request_name}</DialogTitle>
                      <DialogContent>
                        {submitted && !errorMessages.length ? (
                          <Box
                            sx={{
                              textAlign: "center",
                              justifyContent: "center",
                              border: 1,
                              borderRadius: 1,
                              p: 3,
                              mb: 2,
                            }}
                          >
                            <h3 style={{ color: "green" }}>
                              Request Logged Successfully
                            </h3>
                          </Box>
                        ) : errorMessages.length > 0 ? (
                          <Box
                            sx={{
                              textAlign: "center",
                              justifyContent: "center",
                            }}
                          >
                            <Typography variant="h6" component="h2" color="red">
                              Failed Requests
                            </Typography>
                            <List
                              sx={{
                                textAlign: "center",
                                justifyContent: "center",
                                border: 1,
                                borderRadius: 1,
                                p: 3,
                                mb: 2,
                                overflowY: 'auto',
                                maxHeight: '400px',  // Optional: Adjust height as needed
                              }}>
                              {errorMessages.map((message, index) => (
                                <ListItem key={index}>
                                  <ListItemText primary={message} />
                                </ListItem>
                              ))}
                              <Button variant="contained" color="primary" onClick={handleDownload}>
                                Download Error Details
                              </Button>
                            </List>
                          </Box>
                        ) : (
                          <form>
                            <Box>
                              {/* <div>{displayForecastGroup}</div> */}

                              <Box
                                sx={{
                                  alignItems: "center",
                                  justifyContent: "center",
                                  border: 1,
                                  borderRadius: 1,
                                  p: 3,
                                  mb: 2,
                                }}
                              >
                                <br />

                                {item.columns_required &&
                                  item.columns_required
                                    .filter((item) => !item.default)
                                    .map((item, index) => (
                                      <>
                                        <Box key={index}>
                                          {" "}
                                          <CustomText>{item.name}</CustomText>
                                          <CustomTextField
                                            type={
                                              item.isNumber ? "number" : "text"
                                            }
                                            required
                                            name={item.name}
                                            id={item.name}
                                            disabled={item.default}
                                            value={formik.values[item.name]}
                                            onChange={formik.handleChange}
                                            // placeholder="Enter member ID"
                                            sx={{ mb: 2 }}
                                            fullWidth
                                          />
                                          <br />
                                        </Box>
                                      </>
                                    ))}
                                <CustomText>Enter Issue Description</CustomText>
                                <CustomTextField
                                  type="text"
                                  multiline
                                  name="issueDescription"
                                  id="issueDescription"
                                  required
                                  value={formik.values.issueDescription}
                                  onChange={formik.handleChange}
                                  placeholder="Describe Issue"
                                  error={
                                    formik.touched.issueDescription &&
                                    Boolean(formik.errors.issueDescription)
                                  }
                                  helperText={
                                    formik.touched.issueDescription &&
                                    formik.errors.issueDescription
                                  }
                                  sx={{ mb: 2 }}
                                  fullWidth
                                />
                                <Box sx={{ textAlign: "center" }}>
                                  {/* <Button onClick={handleCloseTemplate}>Cancel</Button> */}



                                  <CustomButton
                                    // onClick={(e) =>
                                    //   saveFormData(item.request_id)
                                    // }
                                    onClick={formik.handleSubmit}
                                    type="submit"
                                    disabled={submitted || loading}
                                    variant="contained"
                                    sx={{
                                      py: 2,
                                      px: 3,
                                      m: 2,
                                      background: "#58CC02",
                                    }}
                                  >
                                    {loading ? "Submitting" : "Submit"}
                                  </CustomButton>
                                </Box>
                              </Box>
                            </Box>

                            <Box
                              sx={{
                                alignItems: "center",
                                justifyContent: "center",
                                border: 1,
                                borderRadius: 1,
                                p: 3,
                                my: 4,
                              }}
                            >
                              <CustomText sx={{ mt: 4 }}>
                                Upload Csv File for Multiple Requests
                              </CustomText>
                              {/* Download <a href="#">Template</a> */}
                              <Box
                                sx={{
                                  border: 1,
                                  borderStyle: "dashed",
                                  borderRadius: 3,
                                  p: 1,

                                  textAlign: "center",
                                }}
                              >
                                <Grid container sx={{ py: 2, px: 2 }}>
                                  <Grid item xs={8} sx={{ py: 2 }}>
                                    {requestFile && (
                                      <CustomButton
                                        sx={{
                                          p: 1,
                                          "&:hover": {
                                            backgroundColor: "#fbf9f9",
                                          },
                                        }}
                                      >
                                        {" "}
                                        <DeleteOutlineIcon
                                          onClick={() => setRequestFile()}
                                          sx={{ color: "#58CC02" }}
                                        />
                                      </CustomButton>
                                    )}

                                    <CustomButton
                                      component="label"
                                      sx={{
                                        p: 2,
                                        font: "16px bloggerSans",
                                        background: "#58CC02",
                                      }}
                                    >
                                      <input
                                        type="file"
                                        accept=".csv"
                                        id={"requestLogFile"}
                                        onChange={(e) => changeHandler(e)}
                                        hidden
                                      />
                                      {requestFile
                                        ? `${requestFile.name}`
                                        : "Add File"}
                                    </CustomButton>
                                  </Grid>
                                  <Grid item xs={4} sx={{ py: 2 }}>
                                    <CustomButton1
                                      sx={{
                                        width: "50%",
                                        py: "10px",
                                        borderRadius: "0 5px 5px 0",
                                      }}
                                      onClick={handleShowComment}
                                      disabled={!requestFile || fileUploading}
                                    >
                                      {fileUploading
                                        ? "Uploading..."
                                        : "Upload"}
                                    </CustomButton1>
                                  </Grid>
                                  {showBulkComment && (
                                    <>
                                      <CustomText sx={{ mt: 3 }}>
                                        Enter Issue Description
                                      </CustomText>
                                      <CustomTextField
                                        name="bulkComment"
                                        id="bulkComment"
                                        value={bulkComment}
                                        onChange={handleCommentChange}
                                        fullWidth
                                        multiline
                                      />
                                      <CustomButton
                                        onClick={() =>
                                          handleFileSubmit(item.request_id)
                                        }
                                        disabled={!bulkComment}
                                        variant="outlined"
                                        sx={{
                                          py: 2,
                                          px: 4,
                                          m: 2,
                                          color: "#58CC02",
                                          borderColor: "#58CC02",
                                        }}
                                      >
                                        Submit
                                      </CustomButton>
                                    </>
                                  )}
                                  {fileUploadSuccess && (
                                    <Grid
                                      item
                                      xs={12}
                                      sx={{
                                        color: "green",
                                      }}
                                    >
                                      <CustomTitle>
                                        File Uploaded Successfully
                                      </CustomTitle>
                                    </Grid>
                                  )}
                                  {fileUploadFail && (
                                    <Grid
                                      item
                                      xs={12}
                                      sx={{
                                        color: "red",
                                      }}
                                    >
                                      <CustomTitle> Upload Failed</CustomTitle>
                                    </Grid>
                                  )}
                                  {invalidRows.length > 0 && (
                                    <Grid
                                      item
                                      xs={12}
                                      sx={{
                                        color: "red",
                                      }}
                                    >
                                      <CustomText sx={{ fontSize: "14px" }}>
                                        You have {invalidRows.length} invalid
                                        rows
                                      </CustomText>
                                      {invalidRows.length < 21 &&
                                        invalidRows.map((item, index) => (
                                          <CustomText
                                            key={index}
                                            sx={{
                                              display: "inline",
                                              fontSize: "13px",
                                            }}
                                          >
                                            {(index ? "," : "") + item}
                                          </CustomText>
                                        ))}
                                    </Grid>
                                  )}
                                </Grid>
                              </Box>
                            </Box>
                          </form>
                        )}
                      </DialogContent>
                      <DialogActions sx={{ justifyContent: "center" }}>
                        <CustomButton
                          // onClick={(e) => saveFormData()}
                          onClick={handleCloseTemplate}
                          variant="contained"
                          sx={{
                            py: 2,
                            px: 3,
                            m: 2,
                            background: "#58CC02",
                          }}
                        >
                          Cancel
                        </CustomButton>
                      </DialogActions>
                    </Dialog>
                  </>
                ) : null
              )}
          </Box>
        </Box>
      </Box>
    </div>
  );
};

export default LogRequestPage;
